<template>
  <div class="shopsPhysical-search">
    <mu-appbar class="XR-search-head">
      <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>        
      <div slot="default" class="search-ctrl">
        <input class="input-ctrl" placeholder="请输入关键词" v-model="searchName" ref="searchNameCtrl" />          
      </div>
      <mu-flat-button v-on:click="goSearch" slot="right">搜索</mu-flat-button>    
    </mu-appbar>

    <div class="hotSearch">
      <mu-sub-header>热搜</mu-sub-header>
      <div class="hot-list">
        <router-link class="hot-item" to="/shangquan/temai?searchName=一盅春">一盅春</router-link>
        <router-link class="hot-item" to="/shangquan/temai?searchName=茶餐厅">茶餐厅</router-link>
      </div>
    </div>
    
    
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchName : this.$route.query.searchName
    }
  },
  mounted: function() {
    this.$refs.searchNameCtrl.focus()
  },
  methods: {
    GoHistory(){      
      this.$router.goBack()
    },
    hotSearch: function(key){
      var param ='?searchName='+ key
      this.$router.push('/shangquan/temai'+param)
    },
    goSearch: function(){
      var param =''
      if(this.searchName){
        param ='?searchName='+this.searchName
      }
      this.$router.push('/shangquan/temai'+param)
    }
  }
};
</script>

<style>
.shopsPhysical-search .hotSearch{
  overflow: hidden;
  background: white;
}
.shopsPhysical-search .hotSearch .hot-list{
  overflow: hidden;
  padding: 0 16px 16px;
}
.shopsPhysical-search .hotSearch .hot-list .hot-item{
  float: left;
  padding: 0 10px;
  background: #F0F2F5;
  border-radius: 4px;
  margin-right: 10px;
  margin-bottom: 10px;
}
.shopsPhysical-search .hotSearch .hot-list .hot-item ~ .hot-item{
}


.shopsPhysical-search .XR-search-head{
  height: 48px;
  text-align: center;
}
.shopsPhysical-search .XR-search-head.fixed{  
  padding:0;
  position: fixed;
  top:0;
  left: 0;
}
.shopsPhysical-search .XR-search-head .mu-appbar-title {
  font-size: 16px;
}
.shopsPhysical-search .XR-search-head .title .mu-icon-button {
  position: absolute;
  left: 0;
  top: 0;
  color:white;
}
.shopsPhysical-search .XR-search-head .title .title-text {
  margin: 0;
  line-height: 48px;
}


.shopsPhysical-search .XR-search-head .search-ctrl{
  height: 32px;
  line-height: 32px;
  border-radius: 25px;
  padding-right: 10px;
  color:#ccc;
  background: #999;
  overflow: hidden;
}
.shopsPhysical-search .XR-search-head .search-ctrl .input-ctrl{
  float: left;
  line-height: 32px;
  font-size: 12px;
  width: 90%;
  padding-left: 12px;
  background: inherit;
  border: none;
  outline :none;
  text-align: left;
  color:white;
}
.shopsPhysical-search .XR-search-head .search-ctrl .icon-ctrl{
  width: 10%;
  float: right;
  line-height: 28px;
  text-align: right;
  color:#ccc;
}

.shopsPhysical-search .XR-search-head-chip{
  height: 26px;
  margin-top: 3px;
  padding:0 12px 0 4px;
  border-radius: 0;
}
.shopsPhysical-search .XR-search-head-chip .mu-chip-delete-icon{
  width: 16px;
  height: 16px;
}
</style>


// WEBPACK FOOTER //
// src/pages/shangquan/sqSearch.vue